import { render, staticRenderFns } from "./Purchased.vue?vue&type=template&id=0c20f27e&scoped=true"
import script from "./Purchased.vue?vue&type=script&lang=js"
export * from "./Purchased.vue?vue&type=script&lang=js"
import style0 from "./Purchased.vue?vue&type=style&index=0&id=0c20f27e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c20f27e",
  null
  
)

export default component.exports